<script setup lang="ts">
import TrackingToggle from '../TrackingToggle.vue';
import AutoReserveAction from './AutoReserveAction.vue';
import HotelFloatingAction from './HotelFloatingAction.vue';

interface IProps {
    mobileOnly?: boolean;
    desktopOnly?: boolean;
}
const { mobileOnly, desktopOnly } = defineProps<IProps>();
const currentModule = useCurrentItineraryModule();
const { trackingTypes, supportedTrackingTypes, currentLoadingStatus } =
    moduleToRefs(currentModule.value);
const loading = computed(() =>
    ['loading', 'none', 'realtimeLoading'].includes(
        currentLoadingStatus.value ?? 'none'
    )
);
</script>

<template>
    <div
        class="price-actions-container"
        :class="{
            'just-desktop': desktopOnly,
            'just-mobile': mobileOnly,
        }"
    >
        <mr-bullet-list-loader
            v-if="supportedTrackingTypes.length && loading"
            :count="1"
            class="tracking-loader"
        />
        <TrackingToggle
            v-for="trackingType in trackingTypes"
            :key="trackingType"
            :tracking-type
            class="tracking-toggle"
            inner
            :mobile-only
            :desktop-only
        />
        <HotelFloatingAction />
        <AutoReserveAction />
    </div>
</template>

<style lang="scss" scoped>
// eslint-disable-next-line vue-scoped-css/require-selector-used-inside
html[hide-price-actions] .price-actions-container {
    display: none;
}
.tracking-loader {
    width: 100%;
    border-radius: 12px;
    @include shadow();
    padding: 12px 16px;
    z-index: 100;
    background-color: white;
}

// eslint-disable-next-line vue-scoped-css/require-selector-used-inside
.price-actions-container {
    display: flex;
    gap: 8px;
    flex-direction: column;
    justify-content: flex-end;
    align-items: stretch;
    padding: 0;
    max-width: 344px;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    > *:first-child {
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
    }
    > *:last-child {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
    }
    @include shadow();
    &.just-mobile {
        display: none;
    }
    &.just-desktop {
        display: flex;
    }

    @include mobile-only {
        max-width: unset;
        &.just-mobile {
            display: flex;
            margin: 0 !important;
        }
        &.just-desktop {
            display: none;
        }
    }
}

.tracking-toggle {
    &:not(:first-child) {
        border-top: usePalette($p-cool-gray, $p-200) 1px solid;
    }
}
</style>
